/** Valeurs envoyées au backend (snake_case via useSseWithMsal : answer_format) */
export const ANSWER_FORMAT = {
  AUTO: "auto",
  TABLE: "table",
  SYNTHESIS: "synthesis",
  /** Instructions libres — voir custom_output_instructions */
  CUSTOM: "custom",
} as const;

/** Persistance locale des instructions personnalisées (remplaçable plus tard par l’API / ES). */
export const LEGAL_CUSTOM_INSTRUCTIONS_STORAGE_KEY =
  "infravia.answerFormat.customInstructions";

export type AnswerFormat = (typeof ANSWER_FORMAT)[keyof typeof ANSWER_FORMAT];

/** Allure / concision des panneaux RAG (prompts côté serveur). */
export const RAG_REASONING_PACE = {
  SLOW: "slow",
  MEDIUM: "medium",
  FAST: "fast",
} as const;

export type RagReasoningPace =
  (typeof RAG_REASONING_PACE)[keyof typeof RAG_REASONING_PACE];

export const RAG_REASONING_PACE_ORDER: readonly RagReasoningPace[] = [
  RAG_REASONING_PACE.SLOW,
  RAG_REASONING_PACE.MEDIUM,
  RAG_REASONING_PACE.FAST,
] as const;

export const LEGAL_RAG_REASONING_PACE_STORAGE_KEY =
  "infravia.answerFormat.ragReasoningPace";

/** Pages où la modale « format de réponse » s’affiche en ExhaustiveSearch (aligné sur toutes les vues RAG). */
export const LEGAL_ANSWER_FORMAT_PAGES = [
  "legal",
  "oreima",
  "market",
  "mydeal",
] as const;

export function shouldShowAnswerFormatModal(page: string): boolean {
  const p = String(page || "")
    .trim()
    .toLowerCase();
  return (LEGAL_ANSWER_FORMAT_PAGES as readonly string[]).includes(p);
}
